// Import images
import creditCards from "../images/creditCards.jpg";
import notes from "../images/notes.jpg";
import tv from "../images/tv.jpg";
import arduinoHeart from "../images/arduinoHeart.jpg";
import vandyPool from "../images/VandyPool.jpg";
import rateMyDorm from "../images/rateMyDorm.jpg";
import polymarketImg from "../images/polymarket.jpg";
import jobtrackerImg from "../images/jobtracker.jpg";
import nycaptsImg from "../images/nycapts.jpg";
import stylemogulImg from "../images/stylemogul.jpg";
import wafflImg from "../images/waffl.jpg";
import billbuddyImg from "../images/billbuddy.jpg";

export const projectsData = [
  {
    id: 1,
    title: "Polymarket",
    category: "Follow the top traders with ease",
    img: polymarketImg,
    github: "https://polymarket-five-sand.vercel.app",
  },
  {
    id: 2,
    title: "JobTracker",
    category: "Automate your job apps",
    img: jobtrackerImg,
    github: "https://job-tracker-green-kappa.vercel.app/",
  },
  {
    id: 3,
    title: "NYCApts",
    category: "Find NYC apartments with urgency",
    img: nycaptsImg,
    github: "https://github.com/NSPOLE01/NYCApts",
  },
  {
    id: 4,
    title: "StyleMogul",
    category: "Feeding into your consumerism",
    img: stylemogulImg,
    github: "https://github.com/NSPOLE01/StyleMogul",
  },
  {
    id: 5,
    title: "waffl",
    category: "Keep in touch with friends miles away",
    img: wafflImg,
    github: "https://github.com/NSPOLE01/Waffl",
  },
  {
    id: 6,
    title: "BillBuddy",
    category: "Splitting the bill is no longer a pain",
    img: billbuddyImg,
    github: "https://billbuddyfrontend.vercel.app/",
  },
  {
    id: 7,
    title: "VandyDorm",
    category: "Bolstering the way students visualize campus dorms",
    img: rateMyDorm,
    github: "https://github.com/NSPOLE01/ratemydorm",
  },
  {
    id: 8,
    title: "VandyPool",
    category: "Helps Vanderbilt Students save $$$ on airport rides",
    img: vandyPool,
    github: "https://github.com/NSPOLE01/vandypool",
  },
  {
    id: 9,
    title: "Credit Card Cash-Back Maximizer",
    category: "Visualize and maximize cash-back values",
    img: creditCards,
    github: "https://github.com/NSPOLE01/CashBackMaximizer",
  },
  {
    id: 10,
    title: "React and Redux Notes Manager",
    category: "Store, edit and manage your notes easily!",
    img: notes,
    github: "https://github.com/NSPOLE01/NoteManager",
  },
  {
    id: 11,
    title: "React TV Show Adviser",
    category: "Find TV shows you may like",
    img: tv,
    github: "https://github.com/NSPOLE01/TVShowSuggester",
  },
  {
    id: 12,
    title: "Tachycardia and Bradycardia Diagnostic Tool",
    category: "Arduino Microcontroller Wearable Device + Python Script",
    img: arduinoHeart,
    github: "https://github.com/NSPOLE01/DiagnosticTool",
  },
];

//add url to github
